export const workspace = {
  routes: [
    {
      path: "/workspace/library/datasubject-right",
      component: () => import("../workspace-library-datasubject-right-view"),
    },
  ],
};

export const management = {
  routes: [
  ],
};
